import { createFileRoute } from '@tanstack/react-router'
import { ScEmailReviewPage } from '@/features/support-coordination/email-review'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/emails',
)({
  component: ScEmailReviewPage,
})
